<script setup>
import { ref } from 'vue';
import { usePipelineStore } from '../store/usePipeline';
const props = defineProps({ stages: { type: Array, default: () => [] } });
const emit = defineEmits(['saved']);
const store = usePipelineStore();
const isOpen = ref(false); const rows = ref([]); const saving = ref(false);
const open = () => { rows.value = props.stages.map((s) => ({ id: s.id, nome: s.nome, cor: s.cor || '#2ebdff', is_won: !!s.is_won, is_lost: !!s.is_lost, is_scheduled: !!s.is_scheduled })); isOpen.value = true; };
const close = () => { isOpen.value = false; };
const add = () => { rows.value.push({ nome: 'Novo estagio', cor: '#7cc0ff', is_won: false, is_lost: false, is_scheduled: false }); };
const remove = (i) => { rows.value.splice(i, 1); };
const moveUp = (i) => { if (i > 0) { const r = rows.value.splice(i, 1)[0]; rows.value.splice(i - 1, 0, r); } };
const moveDown = (i) => { if (i < rows.value.length - 1) { const r = rows.value.splice(i, 1)[0]; rows.value.splice(i + 1, 0, r); } };
const save = async () => {
  saving.value = true;
  try {
    const payload = rows.value.map((r, idx) => ({ id: r.id, nome: r.nome, ordem: idx, cor: r.cor, is_won: r.is_won, is_lost: r.is_lost, is_scheduled: r.is_scheduled }));
    await store.saveStages(payload);
    emit('saved'); close();
  } finally { saving.value = false; }
};
defineExpose({ open, close });
</script>

<template>
  <div v-if="isOpen" class="fixed inset-0 z-30 flex items-center justify-center bg-n-alpha-black1" @click.self="close">
    <div class="w-[520px] max-w-[92vw] bg-n-solid-2 rounded-xl outline outline-1 outline-n-container shadow-xl flex flex-col max-h-[85vh]">
      <div class="flex items-center justify-between px-4 h-12 border-b border-n-weak">
        <span class="font-medium text-sm text-n-slate-12">Estagios do funil</span>
        <button class="text-n-slate-11 hover:text-n-slate-12 text-lg leading-none" @click="close">&times;</button>
      </div>
      <div class="p-4 flex flex-col gap-2 overflow-y-auto">
        <div v-for="(r, i) in rows" :key="i" class="flex items-center gap-2 bg-n-solid-1 rounded-lg px-2 py-1.5 outline outline-1 outline-n-weak">
          <input v-model="r.cor" type="color" class="w-6 h-6 rounded bg-transparent border-0 cursor-pointer" />
          <input v-model="r.nome" class="flex-1 bg-n-alpha-black2 rounded px-2 py-1 text-sm text-n-slate-12 outline outline-1 outline-n-weak focus:outline-n-brand" />
          <label class="text-xs text-n-slate-11 flex items-center gap-1" title="Ganho"><input v-model="r.is_won" type="checkbox" />G</label>
          <label class="text-xs text-n-slate-11 flex items-center gap-1" title="Perdido"><input v-model="r.is_lost" type="checkbox" />P</label>
          <label class="text-xs text-n-slate-11 flex items-center gap-1" title="Agendado"><input v-model="r.is_scheduled" type="checkbox" />A</label>
          <button class="text-n-slate-11 hover:text-n-slate-12 px-1" @click="moveUp(i)">&uarr;</button>
          <button class="text-n-slate-11 hover:text-n-slate-12 px-1" @click="moveDown(i)">&darr;</button>
          <button class="text-n-ruby-11 hover:opacity-80 px-1" @click="remove(i)">&times;</button>
        </div>
        <button class="text-xs px-3 py-1.5 rounded-lg bg-n-solid-3 text-n-slate-12 hover:bg-n-alpha-2 self-start" @click="add">+ Adicionar estagio</button>
      </div>
      <div class="p-4 border-t border-n-weak flex gap-2 justify-end">
        <button class="text-sm px-3 py-2 rounded-lg bg-n-solid-3 text-n-slate-12" @click="close">Cancelar</button>
        <button :disabled="saving" class="text-sm px-3 py-2 rounded-lg bg-n-brand text-white hover:opacity-90 disabled:opacity-40" @click="save">Salvar</button>
      </div>
    </div>
  </div>
</template>
